import { Injectable } from '@angular/core';
import { TallyReceiptModel } from '../models/tallyentry-api-model';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class TallyReceiptService {

  constructor(private http: HttpClient) {}

  lFN_SaveTallyReceiptEntry(tallyReceiptModel: TallyReceiptModel) {
    return this.http.post(`${environment.ROOT_URL}/jsyogaccounts/saveReceipt`, tallyReceiptModel, { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  lFN_GetCategoryPurpose() {
    return this.http.get(`${environment.ROOT_URL}/jsyogaccounts/categoryPurpose`, { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  lFN_ValidateReceiptNbr(l_receiptVerifyPayload: any) {
    return this.http.post(`${environment.ROOT_URL}/jsyogaccounts/validateReceiptno`, l_receiptVerifyPayload, { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  lFN_GetCategory() {
    return this.http.get(`${environment.ROOT_URL}/jsyogaccounts/category`, { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  lFN_GetFinyearmst() {
    return this.http.get(`${environment.ROOT_URL}/jsyogaccounts/finyearmst`, { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  lFN_GetChequeDuplicacy(l_chequeDupPayload: any) {
    return this.http.post(`${environment.ROOT_URL}/jsyogaccounts/validateChequeNo`, l_chequeDupPayload, { withCredentials: true, responseType: 'text', observe: 'response' });
  }

  lFN_ActivateFinyearMaster(l_finyearId: any) {
    return this.http.patch(`${environment.ROOT_URL}/jsyogaccounts/activateFinyear/finyearmst/` + l_finyearId, null, { withCredentials: true, responseType: 'text', observe: 'response' });
  } 

}
